import * as React from 'react';
import classNames from "classnames";
import styles from './Icon.scss';

export type IconType = Record<string, string>;

export type Props = {
  icon: IconType,
  className?: string,
  [prop: string]: any
};

export default function Icon(props: Props) {
  const { icon, className, ...restProps } = props;
  return React.createElement('svg', { ...icon, className: classNames(styles.icon, className), ...restProps });
};
